<template lang="pug">
el-header
  img(:src="images.logo")
</template>

<script>
export default {
  data () {
    return {
      images:{
        logo: require('@/assets/cuona_nolabel_logo.svg')
      },
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.el-header {
  background: #000;
  height: 36px;
  padding: 12px;
  text-align: center;

  img {
    width: 36px;
  }
}

</style>